export enum RelationshipsAndGuarantorsConstants {
  SET_RELATIONSHIP = 'relationshipsAndGuarantors/SET_RELATIONSHIP',
  SET_NEXT_OF_KIN = 'relationshipsAndGuarantors/SET_NEXT_OF_KIN',
  SET_SAME_RESIDENCE = 'relationshipsAndGuarantors/SET_SAME_RESIDENCE',
  SET_FIRST_NAME = 'relationshipsAndGuarantors/SET_FIRST_NAME',
  SET_MIDDLE_INITIAL = 'relationshipsAndGuarantors/SET_MIDDLE_INITIAL',
  SET_LAST_NAME = 'relationshipsAndGuarantors/SET_LAST_NAME',
  SET_SUFFIX = 'relationshipsAndGuarantors/SET_SUFFIX',
  SET_UNKNOWN_NAME = 'relationshipsAndGuarantors/SET_UNKNOWN_NAME',
  SET_DOB = 'relationshipsAndGuarantors/SET_DOB',
  SET_AGE = 'relationshipsAndGuarantors/SET_AGE',
  SET_AGE_UNIT = 'relationshipsAndGuarantors/SET_AGE_UNIT',
  SET_SSN = 'relationshipsAndGuarantors/SET_SSN',
  SET_DRIVERS_LICENSE = 'relationshipsAndGuarantors/SET_DRIVERS_LICENSE',
  SET_DRIVERS_LICENSE_STATE = 'relationshipsAndGuarantors/SET_DRIVERS_LICENSE_STATE',
  SET_RESPONSE = 'relationshipsAndGuarantors/SET_RESPONSE',
  SET_RELATIONSHIPS_AND_GUARANTORS_STATE = 'relationshipsAndGuarantors/SET_RELATIONSHIPS_AND_GUARANTORS_STATE',
  RESET_RELATIONSHIPS_AND_GUARANTORS_STATE = 'relationshipsAndGuarantors/RESET_RELATIONSHIPS_AND_GUARANTORS_STATE',
  ADD_RELATIONSHIPS_AND_GUARANTORS = 'relationshipsAndGuarantors/ADD_RELATIONSHIPS_AND_GUARANTORS',
  SET_RELATIONSHIPS_AND_GUARANTORS_LIST = 'relationshipsAndGuarantors/SET_RELATIONSHIPS_AND_GUARANTORS_LIST',
  SET_RELATIONSHIPS_AND_GUARANTORS_DATA = 'relationshipsAndGuarantors/SET_RELATIONSHIPS_AND_GUARANTORS_DATA',
  CLEAR_RELATIONSHIPS_AND_GUARANTORS_DATA = 'relationshipsAndGuarantors/CLEAR_RELATIONSHIPS_AND_GUARANTORS_DATA',
  REMOVE_RELATIONSHIPS_AND_GUARANTORS = 'relationshipsAndGuarantors/REMOVE_RELATIONSHIPS_AND_GUARANTORS',
  SAVE_STATE = 'relationshipsAndGuarantors/SAVE_STATE',
}
